// extracted by mini-css-extract-plugin
module.exports = {"renamedText":"customTitlePopover_renamedText__2Eu0I","popoverTitle":"customTitlePopover_popoverTitle__3-M__"};